import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/refresh`;

export const ROUTE: RouteDefinition = `${baseRoute}/refresh`;

export const URL = (): RouteDefinition => `${baseRoute}/refresh`;
